export const APP_BACKEND_URL = process.env.REACT_APP_APP_BACKEND_URL || 'http://localhost:3001';

export type LiveAccessStatus = {
    gateEnabled: boolean;
    hasAccess: boolean;
};

/** Email from live-rankings session cookie, or null if none / unauthorized. */
export async function getLiveAccessSessionEmail(): Promise<string | null> {
    const r = await fetch(`${APP_BACKEND_URL}/api/live/access/me`, {
        credentials: 'include',
    });
    if (r.status === 401) return null;
    if (!r.ok) return null;
    const data = (await r.json().catch(() => ({}))) as { email?: string };
    return typeof data.email === 'string' ? data.email.toLowerCase() : null;
}

export async function getLiveAccessStatus(): Promise<LiveAccessStatus> {
    const r = await fetch(`${APP_BACKEND_URL}/api/live/access/status`, {
        credentials: 'include',
    });
    if (!r.ok) {
        throw new Error('No se pudo comprobar el acceso');
    }
    return r.json() as Promise<LiveAccessStatus>;
}

export async function requestLiveAccessEmail(
    email: string,
    newsletterOptIn: boolean,
    returnPath?: string
): Promise<{ message: string }> {
    const r = await fetch(`${APP_BACKEND_URL}/api/live/access/request`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newsletterOptIn, returnPath }),
    });
    if (r.status === 404) {
        return { message: 'El acceso restringido no está activo.' };
    }
    const data = (await r.json().catch(() => ({}))) as { message?: string; error?: string };
    if (!r.ok) {
        throw new Error(data.message || data.error || 'No se pudo enviar el correo');
    }
    return { message: data.message || 'Revisa tu correo.' };
}
